import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';

export const templateAddProductMenu = document.createElement('template');

templateAddProductMenu.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='add-product-wrapper'>
    <div id='add-product-inner-container'>
      <gz-title fontSize='14' fontWeight='500' class='company-name' id='add-product-company-name'></gz-title>
      <gz-title fontSize='24' fontWeight='500' id='add-product-title'></gz-title>

      <gz-text class='hidden mt-3' fontSize="14" id='add-product-info-text'></gz-text>
      <gz-link type='underline' color='primary' id='add-product-info-link'></gz-link>


      <gz-title fontSize='11' fontWeight='600' id='add-product-form-title'></gz-title>

      <gz-license-pre-paid-subform hasStackedFormFields></gz-license-pre-paid-subform>

      <gz-info-box class='hidden' severity='error' id='add-product-backend-error-container'></gz-info-box>

      <div style='flex: auto;'></div>
    </div>
    <div class='bottom-buttons'>
        <gz-button id='add-product-submit-button' disabled></gz-button>
        <gz-button type='outline' color='secondary' id='add-product-cancel-button'></gz-button>
    </div>
  </div>
`;
